import { Modal, message } from 'antd';
import React from 'react';
import { Alert } from 'antd';
import { apiGet, parseJsonResponse } from './apiClient';

export const handleKiDATA = async (form, triggerFocus, cat, textareaId, address, objektart) => {
  if (!address) return;

  if (!objektart) {
    message.error(
      'Objektart (in Allgemeine Angaben) wird benötigt, um Textautomatisierung zu nutzen!'
    );
    return;
  }

  const confirmContent = (
    <div>
      Möchten Sie eine Textautomatisierung erstellen? <br />
      <br />
      <Alert
        description={<span>Dieser Abruf ist gemäß Ihres Vertrages kostenpflichtig.</span>}
        type="info"
        showIcon
      />
    </div>
  );

  Modal.confirm({
    title: 'Textautomatisierung',
    content: confirmContent,
    onOk: async () => {
      try {
        const response = await apiGet(
          `/helper/ki-data/${cat}?address=${address}&objektart=${objektart}`
        );
        const json = await parseJsonResponse(response);

        if (!json.success) {
          message.error('Fehler beim Laden der automatischen Daten!');
          return;
        }

        const setContent = (id, content, delay = 0) => {
          let text = content
            .replace(/<b>\s*Erläuterungen\s+zur\s+[^<]+<\/b>\s*<br\s*\/?>/gi, '')
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<u>/gi, '')
            .replace(/<\/u>/gi, '');
          setTimeout(() => {
            form.setFieldsValue({ [id]: text });
            triggerFocus(id);
          }, delay);
        };

        if (cat === 'mikrolage') {
          const delimiter = '<br><br><br><br><b>Erläuterungen zur Verkehrsinfrastruktur</b><br>';
          const parts = json.data.html_text.split(delimiter);
          setContent('Lage__Beurteilung_Lage', parts[0]);
          setContent('Lage__Beurteilung_Verkehrslage', parts[1], 100);
        } else {
          setContent(textareaId, json.data.html_text);
        }
      } catch (e) {
        console.error(e);
        message.error('Ein unerwarteter Fehler ist aufgetreten!');
      }
    },
    onCancel() {},
  });
};
